import flagKeys from '@/constants/flagKeys';
import { app } from '@/main';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

export enum OnboardingURL {
  USER_SIGN_UP = '/business-onboarding/your-account',
  USER_SIGN_UP_COMPLETE = '/business-onboarding/your-account/complete',
  CATEGORY = '/business-onboarding/your-business-category',
  YOUR_BUSINESS = '/business-onboarding/your-store',
  YOUR_BUSINESS_COMPLETE = '/business-onboarding/your-store/complete',
  YOUR_BUSINESS_DETAIL = '/business-onboarding/your-store/details',
  YOUR_BUSINESS_PROVIDERS = '/business-onboarding/your-store/providers',
  YOUR_BUSINESS_OPERATION = '/business-onboarding/your-store/operation',
  YOUR_BUSINESS_ADDRESS = '/business-onboarding/your-store/address',
  YOUR_BUSINESS_PREVIEW = '/business-onboarding/your-store/preview',

  // WELCOME FLOW
  WELCOME_TWISM = '/business-onboarding/welcome-twism',
  WELCOME_TWISM_CONNECTIONS = '/business-onboarding/welcome-twism-connections',

  // INVITATION FLOW
  INVITATION_CREATE_ACCOUNT_OWNER = '/business-onboarding/invitation-create-account-owner',
  INVITATION_LOGIN_ACCOUNT_OWNER = '/business-onboarding/invitation-login-account-owner',
  INVITATION_WELCOME = '/business-onboarding/invitation-welcome',
  INVITATION_CREATE_ACCOUNT = '/business-onboarding/invitation-create-account',

  // HUBSPOT INTEGRATION FLOW
  INVITATION_MERCHANT_SIGNUP = '/business-onboarding/invitation-merchant-create-account',
  INVITATION_MERCHANT_SIGNUP_LOGIN = '/business-onboarding/invitation-merchant-create/login',

  // AI SIGNUP FLOW
  AI_BUSINESS_PREVIEW = '/business-onboarding/ai-business-preview',
  AI_BUSINESS_EDIT = '/business-onboarding/ai-business-edit',
  AI_BUSINESS_COMPLETE = '/business-onboarding/ai-business-complete',
  AI_LOADING = '/business-onboarding/ai-loading',
  AI_CAMPAIGNS = '/business-onboarding/ai-campaigns',
  AI_USER_SIGN_UP = '/business-onboarding/ai-your-account',
  AI_USER_SIGN_UP_COMPLETE = '/business-onboarding/ai-your-account/complete',
  AI_CREATE_CAMPAIGNS = '/business-onboarding/ai-create-campaigns',
  AI_COIN_NETWORK = '/business-onboarding/ai-coin-network'
}

export enum OnlineOnboardingURL {
  BRANDED_COIN = '/online-business-onboarding/your-digital-coin',
  LOADING_ONBOARDING = '/online-business-onboarding/loading-onboarding',
  USER_SIGN_UP = '/online-business-onboarding/your-account',
  LOYALTY_WIDGET = '/online-business-onboarding/loyalty-widget',
  REWARD_RATIO = '/online-business-onboarding/reward-ratio',
  CHOOSE_LOYALTY_REWARD = '/online-business-onboarding/choose-loyalty-reward',
  YOUR_BUSINESS = '/online-business-onboarding/your-store',
  LOYALTY_FEEDBACK_STATUS = '/online-business-onboarding/loyalty-feedback-status'
}

export function getSignUpUrl(loading = false) {
  if (isExternalOauthSessionOnline()) {
    if (loading) return OnlineOnboardingURL.LOADING_ONBOARDING;
    return OnlineOnboardingURL.YOUR_BUSINESS;
  }

  const flags = app.$store.getters['flags/getFlags'];

  if (flags.includes(flagKeys.physicalBusinessOnboardingQ12026)) {
    window.location.href = '/business-onboarding/your-digital-coin';
    return '';
  }

  return getSignUpUrlRoutes().YOUR_BUSINESS;
}

export function getSignUpUrlPrefix() {
  if (isExternalOauthSessionOnline()) {
    return '/online-business-onboarding';
  }

  return '/business-onboarding';
}

export function getSignUpUrlRoutes() {
  if (isExternalOauthSessionOnline()) {
    return OnlineOnboardingURL;
  }

  return OnboardingURL;
}
